import { Component, Input, OnInit } from '@angular/core';
import { IDeviceContract } from '@nx-fe/services';

@Component({
  selector: 'app-card-storage',
  templateUrl: './card-storage.component.html',
  styleUrls: ['./card-storage.component.scss'],
})
export class CardStorageComponent implements OnInit {
  @Input() device: IDeviceContract;

  constructor() {}

  ngOnInit() {
    
  }
}
